import { BulkAction } from 'labstep-web/components/Entity/Search/BulkActions';
import { Filter } from 'labstep-web/constants/filters';

export const filters = [
  Filter.date_range,
  Filter.tag,
  Filter.deleted,
];

export const bulkActions = [
  BulkAction.delete,
  BulkAction.transfer_ownership,
  BulkAction.share,
];
